import { FolkloreType } from '../../apollo/__generated__/graphql';

export const folkloreNameByFolklore: Record<FolkloreType, string> = {
  [FolkloreType.Faluchard]: 'Faluchard',
  [FolkloreType.Impetrant]: 'Impétrant',
  [FolkloreType.Other]: 'Autre',
  [FolkloreType.Sympathisant]: 'Sympathisant',
};
